import axiosInstance from '../RestClient';

class ReportService {
	async listHeavy() {
		return axiosInstance.get('/reports/heavy');
	}

	async createHeavy(reportType, filters) {
		return axiosInstance.post('/reports/heavy', { reportType, filters });
	}

	async downloadHeavy(reportId) {
		return axiosInstance.get(`/reports/heavy/${reportId}/download`);
	}
}

export default new ReportService();
